import React, { useState } from "react";
import {
    Popover,
    Box,
    FormControlLabel,
    Checkbox,
    Button,
    IconButton,
    Typography,
    Divider,
    Stack,
    Badge,
    Tooltip,
} from "@mui/material";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { intl } from "dmsbasereact";
import PropTypes from "prop-types";

export const ColumnManager = ({ columns, visibility, onVisibilityChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleToggle = (columnName) => {
        onVisibilityChange({
            ...visibility,
            [columnName]: visibility[columnName] === false ? true : false,
        });
    };

    const handleShowAll = () => {
        const all = {};
        columns.forEach((col) => {
            all[col.column_name] = true;
        });
        onVisibilityChange(all);
    };

    const handleHideAll = () => {
        const all = {};
        columns.forEach((col) => {
            all[col.column_name] = false;
        });
        onVisibilityChange(all);
    };

    const visibleCount = columns.filter(
        (col) => visibility[col.column_name] !== false
    ).length;

    const hiddenCount = columns.length - visibleCount;

    return (
        <>
            <Tooltip title={intl.get("ManageColumns").d("Gerenciar Colunas")}>
                <IconButton
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    size="small"
                    sx={{ color: "white" }}
                >
                    <Badge
                        badgeContent={hiddenCount}
                        color="error"
                        invisible={hiddenCount === 0}
                    >
                        <ViewColumnIcon />
                    </Badge>
                </IconButton>
            </Tooltip>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Box
                    sx={{
                        p: 2,
                        minWidth: 220,
                        maxHeight: 400,
                        overflow: "auto",
                    }}
                >
                    <Typography variant="subtitle2" gutterBottom>
                        {intl.get("Columns").d("Colunas")} ({visibleCount}/
                        {columns.length})
                    </Typography>

                    <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                        <Button size="small" onClick={handleShowAll}>
                            {intl.get("ShowAll").d("Todas")}
                        </Button>
                        <Button size="small" onClick={handleHideAll}>
                            {intl.get("HideAll").d("Nenhuma")}
                        </Button>
                    </Stack>

                    <Divider sx={{ mb: 1 }} />

                    <Stack>
                        {columns.map((col) => (
                            <FormControlLabel
                                key={col.column_name}
                                sx={{ ml: 0 }}
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={
                                            visibility[col.column_name] !== false
                                        }
                                        onChange={() =>
                                            handleToggle(col.column_name)
                                        }
                                    />
                                }
                                label={col.label}
                            />
                        ))}
                    </Stack>
                </Box>
            </Popover>
        </>
    );
};

ColumnManager.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            column_name: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    visibility: PropTypes.object.isRequired,
    onVisibilityChange: PropTypes.func.isRequired,
};

export default ColumnManager;
